import Vue from "vue";
import Vuex from "vuex";
import modules from "./modules";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    auth: modules.auth,
    points: modules.points,
    combos: modules.combos,
    condos: modules.condos,
    contracts: modules.contracts,
    sms: modules.sms,
    plans: modules.plans,
    client: modules.client,
    cars: modules.cars,
    carTransfers: modules.carTransfers,
    drivers: modules.drivers,
    leads: modules.leads,
    tenant: modules.tenant,
    internalAffairs: modules.internalAffairs,
  },
});

export default store;
